import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ActionsEnum,
  completeMigration,
  markOnboardingAsCompleted,
} from './onboarding-data.actions';
import { Observable } from 'rxjs';
import { onActions } from '../../utils/helpers/redux.helper';
import { Actions } from '@ngrx/effects';
import { v4 } from 'uuid';

@Injectable()
export class OnboardingDataDispatcher {
  constructor(private _store: Store<any>, private _actions: Actions) {}

  /**
   * This action delete the `createFlag` cookie from browser so the onboarding flow doesn't show up again on refresh.
   */
  markOnboardingAsCompleted() {
    this._store.dispatch(markOnboardingAsCompleted());
  }

  completeMigration(): Observable<void> {
    const dispatchId = v4();

    this._store.dispatch(completeMigration(dispatchId));

    return onActions(
      this._actions,
      [
        ActionsEnum.COMPLETE_MIGRATION_SUCCESS,
        ActionsEnum.COMPLETE_MIGRATION_ERROR,
      ],
      dispatchId
    );
  }
}
